module.exports = __webpack_public_path__ + "img/west-vvip-gal-13.16d2a124.jpg";